import { isProd } from './isProd'

// category - address, hash
export const generateCampScanUrl = (category, value) => {
  const baseUrl = isProd
    ? 'https://camp.cloud.blockscout.com'
    : 'https://basecamp.cloud.blockscout.com'

  if (category === 'address') {
    return `${baseUrl}/address/${value}`
  }

  return `${baseUrl}/tx/${value}`
}
